import React from "react";
import { Carousel } from "antd";
import { motion } from "framer-motion";
import { zoomIn } from "../components/motionUtils";
import { Navigation } from "../components/Navigation";
import { resume } from "../data/resume";
import "./works.scss";

const cardVariants = {
  offscreen: {
    y: 320,
  },
  onscreen: {
    y: 10,
    transition: {
      type: "spring",
      bounce: 0.6,
      duration: 0.8,
    },
  },
  exit: {
    y: 320,
    transition: {
      type: "spring",
      bounce: 0.4,
      duration: 0.8,
    },
  },
};

const Card = () => {
  return resume.works.map((company, index) => {
    return (
      <motion.div
        initial="offscreen"
        whileInView="onscreen"
        exit="exit"
        variants={cardVariants}
        viewport={{ once: false, amount: 0.1 }}
        key={index}
        className="w-full flex flex-col-reverse sm:flex-row items-center justify-between shadow-md sm:shadow-lg text-[#333] border-t-2 border-t-[#f9f9f9] sm:rounded-2xl rounded-lg p-2 sm:p-4"
      >
        <div className="w-full h-full flex flex-col-reverse sm:w-full sm:flex-row">
          <div className="w-full sm:w-1/2 flex flex-col justify-center items-start">
            <h1 className="font-lora text-2xl">
              <a href={company.href} target="_blank" rel="noreferrer">
                <b>{company.company_name}</b>
              </a>
            </h1>
            <p className="font-lora text-base font-semibold">
              <b>{company.position}</b>
            </p>
            <p className="font-lora text-base font-semibold">
              <b>{company.text}</b>
            </p>
          </div>
          <div className="w-full h-full sm:w-1/2">
            <Carousel className="w-full" autoplay pauseOnHover>
              {company.url.map((item, index) => (
                <div key={index} className="w-full pb-4">
                  <div className="w-full flex flex-row items-center justify-center">
                    <img src={item} alt="work sample" />
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </motion.div>
    );
  });
};

export const Works = () => {
  return (
    <div className="flex flex-col gap-1 px-8 pb-2 md:px-16 lg:px-60 md:pb-8 bg-whiteBackground w-full h-full font-poppins">
      <div className="w-full flex flex-col-reverse items-center justify-center sticky top-0 left-0 right-0 z-50 bg-whiteBackground py-2 md:py-8">
        <Navigation />
      </div>
      <div className="flex flex-col gap-16 py-10 sm:py-40 md:py-10 bg-whiteBackground w-full">
        <div className="flex flex-row items-center justify-between w-full">
          <div className="font-thin text-xs flex flex-col space-y-3 w-2/3 sm:w-3/4">
            <motion.div
              variants={zoomIn(0, 1)}
              whileInView="show"
              initial="hidden"
              viewport={{ once: false, amount: 0.25 }}
              className="w-full"
            >
              <h1 className="font-lora text-2xl sm:text-6xl">{resume.name}</h1>
              <p className="font-semibold sm:text-xl">
                <b>{resume.role}</b>
              </p>
            </motion.div>
          </div>
          <div className="font-thin text-[0.5rem] sm:text-base w-1/3 sm:w-1/4">
            <motion.div
              variants={zoomIn(0, 2)}
              whileInView="show"
              initial="hidden"
              viewport={{ once: false, amount: 0.25 }}
              className="w-full"
            >
              <p>Contact Information:</p>
              <p className="font-semibold">{resume.phone}</p>
              <div className="flex flex-row items-center gap-1">
                <span className="relative flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-[#ffa500]"></span>
                </span>
                <a
                  className="text-sky-500 font-semibold cursor-pointer"
                  href={`mailto: ${resume.email}`}
                >
                  E-mail me
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      {/* works section */}
      <div className="w-full text-sm sm:text-base flex flex-col items-center justify-center gap-10 min-h-full">
        <p className="w-full text-left">
          This section showcases my personal works, and/or intellectual property
          my present or previous job contracts permit me to expose. <br />
          <br />
          <b> Please scroll down to reveal works</b>
        </p>
        <Card />
      </div>
      <div
        className="h-14 w-14 rounded-[50%] bg-white shadow-lg border-0 text-darkBlack font-extrabold text-xl flex flex-row items-center justify-center animate-[bounce_1.5s_infinite_100ms] cursor-pointer"
        onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })}
      >
        ↑
      </div>
    </div>
  );
};
